import React, { useRef, Fragment } from "react";
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/models/dom/model';
import './custom_content.css'
import ReactHtmlParser from 'react-html-parser';
import * as DOMPurify from 'dompurify';
import { observer } from 'mobx-react';

export const RTEComponent = observer((props: IRTEProps) => {
    const editorRef: any = useRef(null);
    const handleEditorChange = (content, editor) => {
        props.saveCallback(content);
    }
    const handleOnBlur = props.onBlur;
    return (
        <Fragment>
            <Editor
                initialValue={props.initialValue ? props.initialValue : ""}
                onInit={(evt, editor) => { editorRef.current = editor; }}
                id="tinymce-editor"
                init={
                    {
                        promotion: false,
                        statusbar: false,
                        skin: false,
                        content_css: "./custom_content.css",
                        content_style: "body { font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif; }",
                        theme_advanced_font_sizes: "10px,12px,13px,14px,16px,18px,20px",
                        font_size_style_values: "10px,12px,13px,14px,16px,18px,20px",
                        resize: false,
                        menubar: false,
                        plugins: ['lists'],
                        toolbar: 'bold italic underline | bullist numlist',
                    }
                }
                value={props.contentString}
                onEditorChange={handleEditorChange}
                onBlur={handleOnBlur}
            />
        </Fragment>
    )
})

/**
 * Rich Text Display Component.
 * 
 * Used to display previously exported Rich Text Editor HTML strings via react-html-parser.
 * @param props 
 * @returns 
 */
export const RTDComponent = observer((props: IRTDProps) => {
    const sanitizedHtml = DOMPurify.sanitize(props.htmlString);
    return (
        <Fragment>
            {ReactHtmlParser(sanitizedHtml)}
        </Fragment>
    );
});

interface IRTEProps {
    saveCallback: (...args) => void;
    initialValue?: string;
    contentString: string;
    onBlur?:any;
}
interface IRTDProps {
    htmlString: string,
}

